import React from "react";
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import '../assets/styles/Main.scss';
import EmailIcon from '@mui/icons-material/Email'; // Make sure to import the email icon
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import profile from '../assets/images/profile.jpeg';
import SmartToyIcon from '@mui/icons-material/SmartToy';

import profilepic from '../assets/images/profile.jpg'

import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import AgricultureIcon from '@mui/icons-material/Agriculture';
import EmojiTransportationIcon from '@mui/icons-material/EmojiTransportation';
import DeleteSweepIcon from '@mui/icons-material/DeleteSweep';
import SettingsInputAntennaIcon from '@mui/icons-material/SettingsInputAntenna';

function Main() {

  return (
    <div className="container">
      <div className="about-section">
        <div className="image-wrapper">
          <img src={profilepic} alt="Avatar" />
        </div>
        <div className="content">
          
          <h1>H. A. Hassan</h1>
          <p style={{ fontWeight: 'bold' }}>Full Stack Engineer</p>
          <div style={{fontSize : '1rem'}}>
            <p> <SmartToyIcon sx={{ marginRight: '8px', color: '#1976d2' }} /> Having expertise in AI, helps businesses to save money by automating workflows.</p>
          </div>

          <div style={{ marginTop: '1.2rem' }}>
            {["LLMs", "VLMs", "React", "Django", "AWS"].map((domain) => (
              <span key={domain} style={{
                display: "inline-block",
                backgroundColor: "#e0e0e0",
                color: "#333",
                padding: "5px 10px",
                borderRadius: "15px",
                margin: "5px 5px 5px 0",
                fontSize: "0.9rem"
              }}>{domain}</span>
            ))}
          </div>


          
          <div className="social_icons">
            <a href="https://github.com/hafizahmadhassan" target="_blank" rel="noreferrer"><GitHubIcon/></a>
            <a href="https://www.linkedin.com/in/hafizahmadhassan/" target="_blank" rel="noreferrer"><LinkedInIcon/></a>
            <a href="mailto:ahmahassan061@gmail.com" target="_blank" rel="noreferrer"><EmailIcon /></a>

          </div>
          <div className="mobile_social_icons">
            <a href="https://github.com/hafizahmadhassan" target="_blank" rel="noreferrer"><GitHubIcon/></a>
            <a href="https://www.linkedin.com/in/hafizahmadhassan/" target="_blank" rel="noreferrer"><LinkedInIcon/></a>
            <a href="mailto:ahmahassan061@gmail.com" target="_blank" rel="noreferrer"><EmailIcon /></a>

          </div>
        </div>
      </div>
    </div>
  );
}

export default Main;